import React from 'react';
import { FiPaperclip } from 'react-icons/fi';

const Message = ({ message }) => {
    const messageClass = message.isUser ? 'message user' : 'message bot';
    const linkifyText = (text) => {
        if (!text) return null;

        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (part.match(urlRegex)) {
            const cleanUrl = part.replace(/[.,!?)]*$/, "");

            return (
                <a
                key={index}
                href={cleanUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1a73e8", textDecoration: "underline" }}
                >
                {cleanUrl}
                </a>
            );
            }
            return part;
        });
    };

    return (
        <div className={messageClass}>
            {message.text && <div>{linkifyText(message.text)}</div>}
            
            {message.imageResponse && (
                <img
                    src={`data:image/jpeg;base64,${message.imageResponse}`}
                    alt="Visual response"
                    className="response-image"
                />
            )}

            {message.fileResponse && (
                <div className="file-preview">
                    <FiPaperclip size={18} />
                    <a 
                        href={`data:application/octet-stream;base64,${message.fileResponse.replace(/^data:.*;base64,/, '')}`} 
                        download="response-file"
                        className="download-link"
                    >
                        Download attached file
                    </a>
                </div>
            )}

            <div className="timestamp">
                {message.timestamp}
            </div>
        </div>
    );
};

export default Message;